import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-factory-schedule.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import WeekdaysEnum from '../../constants/enums/weekend-enum';
import { useStore } from '../../contexts/store-provider';
import { AddEditHolidayInitialState } from '../../core/initialState';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import { IAddHoliday } from '../../models/forms/IAddEditHoliday';
import { IHolidayVM } from '../../models/response/IHolidayResponse';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditHolidaySchedule from './components/add-holiday-calendar';
import AddEditWeekend from './components/add-weekend';
import CalendarView from './components/calendar-view';
import ImportHolidays from './components/import-holidays';
import FactoryScheduleDetails from './factory-schedule-details';
import './factory-schedule.css';
import AddFactorySchedulePopupHOC from './hoc/add-factory-schedule-popup-hoc';
import AddHolidayCalendarPopupHOC from './hoc/add-holiday-calendar-popup-hoc';
import ImportHolidayPopupHOC from './hoc/add-import-holiday-popup-hoc';
import DeleteAllFactorySchedulePopupHOC from './hoc/delete-all-factory-schedule-popup-hoc';

const FactorySchedule = (props: any) => {
  const { preferencesStore, factoryScheduleStore } = useStore();
  const [year, setYear] = useState(new Date().getFullYear());
  const handlePreviousYear = () => {
    setYear(year - 1);
    closePanelHandler();
    setSelectedDate(new Date(year - 1, 0, 1));
  };
  const handleNextYear = () => {
    setYear(year + 1);
    closePanelHandler();
    setSelectedDate(new Date(year + 1, 0, 1));
  };

  const {
    userSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    GetFactoryScheduleListService,
    allFactorySchedule,
    deleteFactoryScheduleState,
    DeleteFactoryScheduleService,
    resetDeleteFactoryScheduleState,
    addUpdateFactoryScheduleState,
    resetAddUpdateFactoryScheduleState,
    GetFactoryScheduleByIdService,
    getFactoryScheduleByIdState,
    getAllFactoryScheduleState,
    resetFactoryScheduleDetail,
    AddFactoryWeekendService,
    addEditFactoryWeekendState,
    allFactoryWeekendSchedule,
    resetAddEditFactoryWeekendState,
    ExportFileService,
    exportFileState,
    resetExportFileState,
    base64String,
    fileUploadState,
    resetFileUploadState,
    calendarHolidays,
    weekendDays,
    DeleteAllFactoryScheduleService,
    deleteAllFactoryScheduleState,
    resetDeleteAllFactoryScheduleState,
  } = factoryScheduleStore;

  let lang: string;
  const allHolidayListData = allFactorySchedule;
  const [firstOff, setFirstOff] = useState(-1);
  const [secondOff, setSecondOff] = useState(-1);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [selectedDate, setSelectedDate] = useState<Date>(null);
  const [filterObj, setFilterObj] = useState<IAddHoliday>(
    AddEditHolidayInitialState
  );
  const [toggleView, setToggleView] = useState(false);
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const getHolidayListServiceHandler = () => {
    GetFactoryScheduleListService(Number(getTenantIdFromLocalStorage()), year);
  };

  // useEffect(() => {
  //   getHolidayListServiceHandler();
  // }, []);

  useEffect(() => {
    getHolidayListServiceHandler();
  }, [year]);

  useEffect(() => {
    if (allFactoryWeekendSchedule && allFactoryWeekendSchedule.length > 0) {
      setFirstOff(WeekdaysEnum[allFactoryWeekendSchedule[0]?.Day]);
      setSecondOff(WeekdaysEnum[allFactoryWeekendSchedule[1]?.Day]);
    }
  }, [allFactoryWeekendSchedule]);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(formatMessage('added_success'));
      resetFileUploadState();
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploadState.success]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getHolidayListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getHolidayListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateFactoryScheduleState.success) {
      resetAddUpdateFactoryScheduleState();
      getHolidayListServiceHandler();
    }
    closePanelHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateFactoryScheduleState.success]);

  useEffect(() => {
    if (deleteFactoryScheduleState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteFactoryScheduleState();
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFactoryScheduleState.success]);

  useEffect(() => {
    if (deleteAllFactoryScheduleState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deleteAllToggleHandler();
      resetDeleteAllFactoryScheduleState();
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAllFactoryScheduleState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  useEffect(() => {
    if (addEditFactoryWeekendState.success) {
      toast.success(formatMessage('added_success'));
      resetAddEditFactoryWeekendState();
      getHolidayListServiceHandler();
    }
    closePanelHandler();
  }, [addEditFactoryWeekendState.success]);

  const rowEvents = (e: SyntheticEvent, row: any) => {
    GetFactoryScheduleByIdService(
      Number(getTenantIdFromLocalStorage()),
      row.HolidayId
    );
    setSelectedRow(row);
    if (
      selectedRow.HolidayId === undefined ||
      selectedRow.HolidayId !== row.HolidayId
    ) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
    resetFactoryScheduleDetail();
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getHolidayListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteFactoryScheduleService(
      Number(getTenantIdFromLocalStorage()),
      selectedId,
      year
    );
  };

  const deleteAllHandler = () => {
    closePanelHandler();
    DeleteAllFactoryScheduleService(
      Number(getTenantIdFromLocalStorage()),
      year
    );
  };

  const deleteClickHandler = (
    row: IHolidayVM,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (year < new Date().getFullYear()) return;
    setSelectedId(row.HolidayId);
    event.stopPropagation();
    closePanelHandler();
    resetFactoryScheduleDetail();
    props.deletePopupToggleHandler();
  };

  const calendarViewDeleteClickHandler = (
    holidayId: number,
    holidayYear: number
  ) => {
    if (holidayYear < new Date().getFullYear()) return;
    props.deletePopupToggleHandler();
    setSelectedId(holidayId);
    setYear(holidayYear);
  };

  const handleExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `HolidaysExportFile-${Date.now()}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    closePanelHandler();
    resetFactoryScheduleDetail();
  };

  useEffect(() => {
    if (exportFileState.success && base64String.fileString.length > 0) {
      handleExport(base64String.fileString);
      resetExportFileState();
    }
  }, [exportFileState.success]);

  useEffect(() => {
    const savedToggleState = localStorage.getItem('toggleView');
    setToggleView(savedToggleState !== null && savedToggleState === 'true');
  }, [toggleView]);

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable:
          !isOperationPermittedRoleBase(ModuleType.HolidayCalendar, 'Delete') ||
          year < new Date().getFullYear(),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },

    ],
    ModuleType.HolidayCalendar
  );

  const columns: any = [
    {
      dataField: 'HolidayDate',
      text: formatMessage('factory_schedule_holiday_date'),
      classes: 'show-Elipses',
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Day',
      text: formatMessage('factory_schedule_day'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },

    {
      dataField: 'HolidayName',
      text: formatMessage('factory_schedule_holiday_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Comment',
      text: formatMessage('factory_schedule_comment'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  const openImportFiletHandler = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (year < new Date().getFullYear()) return;
    event.stopPropagation();
    closePanelhandler();
    props.addToggleHandler();
    resetFactoryScheduleDetail();
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const exportFiletHandler = () => {
    ExportFileService(Number(getTenantIdFromLocalStorage()), year);
  };

  return (
    <>
      {props.showImportPopup && (
        <ImportHolidays
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showDeletePopup && (
        <DeletePopup
          title="delete_holiday"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_holiday_confirm"
          isLoading={deleteFactoryScheduleState.inProgress}
        />
      )}

      {props.showDeleteAllPopup && (
        <DeletePopup
          title="delete_all"
          modalSubmit={deleteAllHandler}
          modalClosed={props.deleteAllToggleHandler}
          message="message_delete_all_holiday_confirm"
          isLoading={deleteAllFactoryScheduleState.inProgress}
        />
      )}

      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header className='col-lg-4 col-md-5 col-sm-6' label="factory_schedule_title" />
          <div className="col-lg-8 col-md-7 col-sm-6">
            <ul className="add-list">
              {isOperationPermittedRoleBase(
                ModuleType.HolidayCalendar,
                'Add'
              ) && (
                  <li
                    style={{
                      cursor: `${year < new Date().getFullYear() ? 'not-allowed' : ''}`,
                    }}
                    title={formatMessage('import')}
                  >
                    <a
                      data-toggle="modal"
                      className={`btn btn-light ${year < new Date().getFullYear() ? 'disabled' : ''}`}
                      onClick={(event: any) => openImportFiletHandler(event)}
                    >
                      <svg
                        version="1.1"
                        id="Capa_1"
                        fill="currentColor"
                        width="20"
                        height="20"
                        x="0px"
                        y="0px"
                        viewBox="0 0 405.2 512"
                      >
                        <g>
                          <path
                            d="M214.1,314.1l40-40c7.8-7.8,7.8-20.5,0-28.3s-20.5-7.8-28.3,0l-5.9,5.9V180c0-11-9-20-20-20s-20,9-20,20v71.7l-5.9-5.9
		c-7.8-7.8-20.5-7.8-28.3,0s-7.8,20.5,0,28.3l40,40C193.6,321.9,206.4,321.9,214.1,314.1L214.1,314.1z"
                          />
                          <path
                            d="M394.1,125.8l-120-120C273.9,5.7,268.7,0,260,0H60C26.9,0,0,26.9,0,60v392c0,33.1,26.9,60,60,60h40c11,0,20-9,20-20
		s-9-20-20-20H60c-11,0-20-9-20-20V60c0-11,9-20,20-20h180v60c0,33.1,26.9,60,60,60h60v140c0,11,9,20,20,20s20-9,20-20V140
		C400,134.7,397.9,129.6,394.1,125.8L394.1,125.8z M300,120c-11,0-20-9-20-20V68.3l51.7,51.7H300z"
                          />
                        </g>
                        <g>
                          <path
                            d="M156.2,449.4c0,22.5,9.4,33.7,28.3,33.7c3.4,0,6.6-0.3,9.6-1s6.7-1.7,11-3.2c3.5,7.6,5.8,15.5,7,23.5
		c-3.1,1.2-5.9,2.1-8.6,2.9c-2.6,0.7-5.2,1.3-7.6,1.7c-2.4,0.4-4.8,0.6-7.2,0.8c-2.4,0.2-4.8,0.2-7.4,0.2c-9,0-16.9-1.5-23.8-4.4
		c-6.8-2.9-12.6-7-17.2-12.2c-4.6-5.2-8.1-11.4-10.4-18.6c-2.3-7.2-3.5-15-3.5-23.5c0-8.5,1.2-16.3,3.7-23.6
		c2.4-7.3,6-13.5,10.6-18.8c4.6-5.3,10.3-9.4,17.1-12.4c6.8-3,14.5-4.4,23-4.4c5.1,0,9.9,0.4,14.5,1.1c4.6,0.7,9.6,2.2,15.3,4.4
		c-0.2,4.3-1,8.6-2.4,12.6c-1.4,4.1-2.8,7.7-4.3,10.7c-2.1-0.7-4.1-1.4-5.8-1.9c-1.7-0.5-3.4-1-5-1.3s-3.2-0.6-4.8-0.7
		s-3.3-0.2-5.1-0.2c-8.6,0-15.2,2.9-19.9,8.7C158.6,429.4,156.2,438,156.2,449.4z"
                          />
                          <path
                            d="M270.8,436.5c4.4,1.8,8.4,3.6,12,5.5c3.5,1.9,6.6,4.1,9.1,6.7c2.5,2.6,4.5,5.7,5.9,9.4c1.4,3.7,2.1,8.1,2.1,13.3
		c0,5.6-1,10.7-2.9,15.2c-2,4.5-4.8,8.4-8.7,11.6c-3.8,3.2-8.5,5.7-14.1,7.5c-5.6,1.7-11.9,2.6-19.1,2.6c-6.6,0-12.4-0.5-17.4-1.6
		c-5-1.1-10.5-2.7-16.3-4.9c0.4-3.7,1.2-7.7,2.2-11.8c1.1-4.2,2.3-8.4,3.8-12.8c9.7,4.2,18.2,6.4,25.4,6.4c5.4,0,9.6-0.8,12.6-2.5
		c3-1.6,4.5-4.5,4.5-8.5c0-1.7-0.3-3.2-1-4.4c-0.6-1.2-1.5-2.2-2.5-3.1c-1.1-0.8-2.3-1.6-3.6-2.1c-1.3-0.6-2.7-1.1-4.1-1.7l-8.9-3.3
		c-3.8-1.4-7.3-3-10.4-4.9c-3.1-1.9-5.8-4.2-8-6.8c-2.2-2.6-3.9-5.6-5.2-9c-1.2-3.4-1.8-7.4-1.8-11.9c0-5.6,1-10.6,2.9-14.9
		c1.9-4.3,4.6-8,8-11c3.4-3,7.6-5.3,12.5-6.8c4.9-1.5,10.3-2.3,16.4-2.3c5.4,0,10.6,0.5,15.7,1.6c5,1.1,10.4,2.6,16.1,4.6
		c-0.4,3.4-1.2,7.1-2.3,11.2c-1.1,4.1-2.5,7.9-4.2,11.5c-2.8-1.2-6-2.4-9.7-3.7c-3.7-1.3-8.3-1.9-13.8-1.9c-1.7,0-3.3,0.2-4.8,0.5
		c-1.5,0.3-2.9,0.8-4.1,1.5c-1.2,0.7-2.2,1.6-2.9,2.9c-0.7,1.2-1.1,2.7-1.1,4.5c0,3.1,1,5.3,3,6.8c2,1.5,4.4,2.8,7.2,3.8
		L270.8,436.5z"
                          />
                          <path
                            d="M354.5,469.3l21.8-76.9c2.4-0.4,4.9-0.7,7.4-1c2.5-0.2,5.1-0.3,7.9-0.3c1.8,0,4,0.1,6.7,0.4c2.6,0.3,5,0.6,7,0.9L368.7,506
		c-2.8,0.4-5.3,0.7-7.7,1c-2.4,0.2-4.7,0.3-6.9,0.3c-2.1,0-4.3-0.1-6.5-0.3c-2.2-0.2-4.9-0.5-7.9-1l-36.4-113.6
		c1.8-0.3,4.2-0.6,7.1-0.9c3-0.3,5.8-0.4,8.6-0.4c2.2,0,4.7,0.1,7.3,0.4c2.6,0.3,5,0.6,7,0.9L354.5,469.3z"
                          />
                        </g>
                      </svg>
                    </a>
                  </li>
                )}
              {isOperationPermittedRoleBase(
                ModuleType.HolidayCalendar,
                'Add'
              ) && (
                  <li
                    title={formatMessage('factory_schedule_export')}
                    className={`${allHolidayListData && allHolidayListData.length === 0 ? 'cursor-not-allowed' : ''}`}
                  >
                    <a
                      data-toggle="modal"
                      className={`btn btn-light ${allHolidayListData && allHolidayListData.length === 0 ? 'disabled' : ''}`}
                      onClick={() => exportFiletHandler()}
                    >
                      <svg
                        version="1.1"
                        id="Capa_1"
                        fill="currentColor"
                        width="20"
                        height="20"
                        x="0px"
                        y="0px"
                        viewBox="0 0 405.2 512"
                      >
                        <g>
                          <path
                            d="M185.9,165.8l-40,40c-7.8,7.8-7.8,20.5,0,28.3s20.5,7.8,28.3,0l5.9-5.9V300c0,11,9,20,20,20s20-9,20-20v-71.7l5.9,5.9
		c7.8,7.8,20.5,7.8,28.3,0c7.8-7.8,7.8-20.5,0-28.3l-40-40C206.4,158,193.6,158.1,185.9,165.8L185.9,165.8z"
                          />
                          <path
                            d="M394.1,125.8l-120-120C273.9,5.7,268.7,0,260,0H60C26.9,0,0,26.9,0,60v392c0,33.1,26.9,60,60,60h40c11,0,20-9,20-20
		s-9-20-20-20H60c-11,0-20-9-20-20V60c0-11,9-20,20-20h180v60c0,33.1,26.9,60,60,60h60v140c0,11,9,20,20,20s20-9,20-20V140
		C400,134.7,397.9,129.6,394.1,125.8L394.1,125.8z M300,120c-11,0-20-9-20-20V68.3l51.7,51.7H300z"
                          />
                        </g>
                        <g>
                          <path
                            d="M156.2,449.4c0,22.5,9.4,33.7,28.3,33.7c3.4,0,6.6-0.3,9.6-1s6.7-1.7,11-3.2c3.5,7.6,5.8,15.5,7,23.5
		c-3.1,1.2-5.9,2.1-8.6,2.9c-2.6,0.7-5.2,1.3-7.6,1.7c-2.4,0.4-4.8,0.6-7.2,0.8c-2.4,0.2-4.8,0.2-7.4,0.2c-9,0-16.9-1.5-23.8-4.4
		c-6.8-2.9-12.6-7-17.2-12.2c-4.6-5.2-8.1-11.4-10.4-18.6c-2.3-7.2-3.5-15-3.5-23.5c0-8.5,1.2-16.3,3.7-23.6
		c2.4-7.3,6-13.5,10.6-18.8c4.6-5.3,10.3-9.4,17.1-12.4c6.8-3,14.5-4.4,23-4.4c5.1,0,9.9,0.4,14.5,1.1c4.6,0.7,9.6,2.2,15.3,4.4
		c-0.2,4.3-1,8.6-2.4,12.6c-1.4,4.1-2.8,7.7-4.3,10.7c-2.1-0.7-4.1-1.4-5.8-1.9c-1.7-0.5-3.4-1-5-1.3s-3.2-0.6-4.8-0.7
		s-3.3-0.2-5.1-0.2c-8.6,0-15.2,2.9-19.9,8.7C158.6,429.4,156.2,438,156.2,449.4z"
                          />
                          <path
                            d="M270.8,436.5c4.4,1.8,8.4,3.6,12,5.5c3.5,1.9,6.6,4.1,9.1,6.7c2.5,2.6,4.5,5.7,5.9,9.4c1.4,3.7,2.1,8.1,2.1,13.3
		c0,5.6-1,10.7-2.9,15.2c-2,4.5-4.8,8.4-8.7,11.6c-3.8,3.2-8.5,5.7-14.1,7.5c-5.6,1.7-11.9,2.6-19.1,2.6c-6.6,0-12.4-0.5-17.4-1.6
		c-5-1.1-10.5-2.7-16.3-4.9c0.4-3.7,1.2-7.7,2.2-11.8c1.1-4.2,2.3-8.4,3.8-12.8c9.7,4.2,18.2,6.4,25.4,6.4c5.4,0,9.6-0.8,12.6-2.5
		c3-1.6,4.5-4.5,4.5-8.5c0-1.7-0.3-3.2-1-4.4c-0.6-1.2-1.5-2.2-2.5-3.1c-1.1-0.8-2.3-1.6-3.6-2.1c-1.3-0.6-2.7-1.1-4.1-1.7l-8.9-3.3
		c-3.8-1.4-7.3-3-10.4-4.9c-3.1-1.9-5.8-4.2-8-6.8c-2.2-2.6-3.9-5.6-5.2-9c-1.2-3.4-1.8-7.4-1.8-11.9c0-5.6,1-10.6,2.9-14.9
		c1.9-4.3,4.6-8,8-11c3.4-3,7.6-5.3,12.5-6.8c4.9-1.5,10.3-2.3,16.4-2.3c5.4,0,10.6,0.5,15.7,1.6c5,1.1,10.4,2.6,16.1,4.6
		c-0.4,3.4-1.2,7.1-2.3,11.2c-1.1,4.1-2.5,7.9-4.2,11.5c-2.8-1.2-6-2.4-9.7-3.7c-3.7-1.3-8.3-1.9-13.8-1.9c-1.7,0-3.3,0.2-4.8,0.5
		c-1.5,0.3-2.9,0.8-4.1,1.5c-1.2,0.7-2.2,1.6-2.9,2.9c-0.7,1.2-1.1,2.7-1.1,4.5c0,3.1,1,5.3,3,6.8c2,1.5,4.4,2.8,7.2,3.8
		L270.8,436.5z"
                          />
                          <path
                            d="M354.5,469.3l21.8-76.9c2.4-0.4,4.9-0.7,7.4-1c2.5-0.2,5.1-0.3,7.9-0.3c1.8,0,4,0.1,6.7,0.4c2.6,0.3,5,0.6,7,0.9L368.7,506
		c-2.8,0.4-5.3,0.7-7.7,1c-2.4,0.2-4.7,0.3-6.9,0.3c-2.1,0-4.3-0.1-6.5-0.3c-2.2-0.2-4.9-0.5-7.9-1l-36.4-113.6
		c1.8-0.3,4.2-0.6,7.1-0.9c3-0.3,5.8-0.4,8.6-0.4c2.2,0,4.7,0.1,7.3,0.4c2.6,0.3,5,0.6,7,0.9L354.5,469.3z"
                          />
                        </g>
                      </svg>
                    </a>
                  </li>
                )}

              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <svg
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-repeat m-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path
                      fillRule="evenodd"
                      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                    />
                  </svg>
                </a>
              </li>
              <ul className="tableAccordian-switch d-flex">
                <li
                  className={toggleView === false ? 'active' : ''}
                  onClick={() => {
                    localStorage.setItem('toggleView', JSON.stringify(false));
                    setToggleView((prev) => !prev);
                    getHolidayListServiceHandler();
                  }}
                >
                  <svg
                    id="Layer_1"
                    enableBackground="new 0 0 34 34"
                    height="512"
                    viewBox="0 0 34 34"
                    width="512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path d="m8 1c-.5 0-1 .4-1 1v1h-3c-1.6 0-3 1.3-3 3v4 20c0 1.7 1.3 3 3 3h26c1.7 0 3-1.3 3-3v-20-4c0-1.7-1.3-3-3-3h-3v-1c0-.6-.4-1-1-1s-1 .4-1 1v1h-16v-1c0-.6-.4-1-1-1zm23 29c0 .6-.4 1-1 1h-26c-.6 0-1-.4-1-1v-19h28zm-6-25v1c0 .6.4 1 1 1s1-.4 1-1v-1h3c.6 0 1 .4 1 1v3h-28v-3c0-.6.4-1 1-1h3v1c0 .6.4 1 1 1s1-.4 1-1v-1z" />
                      <path d="m7.1 19.5h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2z" />
                      <path d="m15.1 19.5h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2z" />
                      <path d="m23.1 19.5h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2z" />
                      <path d="m7.1 28.5h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2z" />
                      <path d="m15.1 28.5h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2z" />
                      <path d="m23.1 28.5h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2z" />
                    </g>
                  </svg>
                  <span className="icon-text">{formatMessage('tabular')}</span>{' '}
                </li>
                <li
                  className={toggleView === true ? 'active' : ''}
                  onClick={() => {
                    localStorage.setItem('toggleView', JSON.stringify(true));
                    getHolidayListServiceHandler();
                    setToggleView((prev) => !prev);
                    closePanelHandler();
                    resetFactoryScheduleDetail();
                  }}
                >
                  <svg
                    height="512pt"
                    viewBox="0 0 512 512"
                    width="512pt"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m440.890625 0h-369.78125c-39.257813.0351562-71.0742188 31.851562-71.109375 71.109375v369.78125c.0351562 39.257813 31.851562 71.074219 71.109375 71.109375h369.78125c39.257813-.035156 71.074219-31.851562 71.109375-71.109375v-369.78125c-.035156-39.257813-31.851562-71.0742188-71.109375-71.109375zm-252.445313 362.667969v-99.558594h135.109376v99.558594zm135.109376 28.441406v92.445313h-135.109376v-92.445313zm0-248.886719v92.445313h-135.109376v-92.445313zm160 0v92.445313h-131.554688v-92.445313zm-323.554688 92.445313h-131.554688v-92.445313h131.554688zm-131.554688 28.441406h131.554688v99.558594h-131.554688zm323.554688 0h131.554688v99.558594h-131.554688zm-280.890625-234.664063h369.78125c23.550781.023438 42.640625 19.113282 42.664063 42.664063v42.667969h-455.109376v-42.667969c.023438-23.550781 19.113282-42.640625 42.664063-42.664063zm-42.664063 412.445313v-49.78125h131.554688v92.445313h-88.890625c-23.550781-.023438-42.640625-19.113282-42.664063-42.664063zm412.445313 42.664063h-88.890625v-92.445313h131.554688v49.78125c-.023438 23.550781-19.113282 42.640625-42.664063 42.664063zm0 0" />
                  </svg>
                  <span className="icon-text">{formatMessage('calendar')}</span>
                </li>
              </ul>
              <li
                title={formatMessage('delete_all')}
                className={`${(allHolidayListData && allHolidayListData.length === 0) || year < new Date().getFullYear() ? 'cursor-not-allowed' : ''}`}
              >
                <a
                  className={`btn btn-secondary ${(allHolidayListData && allHolidayListData.length === 0) || year < new Date().getFullYear() ? 'disabled' : ''}`}
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={(event: any) => {
                    if (year >= new Date().getFullYear()) {
                      props.deleteAllToggleHandler();
                    }
                  }}
                >
                  <span className="deleteHoliday me-1">
                    <DeleteIcon />
                  </span>
                  <FormattedMessage id="delete_all" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page overflow-hidden ">
          {(getAllFactoryScheduleState.inProgress ||
            getFactoryScheduleByIdState.inProgress ||
            deleteFactoryScheduleState.inProgress ||
            addEditFactoryWeekendState.inProgress) && (
              <FormLoader
                loading={
                  getAllFactoryScheduleState.inProgress ||
                  getFactoryScheduleByIdState.inProgress ||
                  deleteFactoryScheduleState.inProgress ||
                  addEditFactoryWeekendState.inProgress
                }
              />
            )}
          <div className="year-factory">
            <div className="row g-0">
              <div className="col-3">
                <div className='bg-light p-3'>
                  <div className="mb-3">
                    <label className="form-label">
                      {formatMessage('select_year')}
                    </label>
                    {/* Year Start */}
                    <div className="year-selector-container form-control">
                      <button
                        className="year-selector-button"
                        onClick={handlePreviousYear}
                      >
                        <svg
                          height="512"
                          viewBox="0 0 24 24"
                          width="512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="_17"
                            data-name="17"
                          >
                            <path d="m15 19a1 1 0 0 1 -.71-.29l-6-6a1 1 0 0 1 0-1.41l6-6a1 1 0 0 1 1.41 1.41l-5.29 5.29 5.29 5.29a1 1 0 0 1 -.7 1.71z" />
                          </g>
                        </svg>
                      </button>
                      <div className="year-selector-display">{year}</div>
                      <button
                        className="year-selector-button"
                        onClick={handleNextYear}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="512"
                          height="512"
                          x="0"
                          y="0"
                          viewBox="0 0 24 24"
                        >
                          <g transform="matrix(-1,-1.2246467991473532e-16,1.2246467991473532e-16,-1,23.995043754577637,24.05955696105957)">
                            <path
                              d="M15 19a1 1 0 0 1-.71-.29l-6-6a1 1 0 0 1 0-1.41l6-6a1 1 0 0 1 1.41 1.41L10.41 12l5.29 5.29A1 1 0 0 1 15 19z"
                              data-name="17"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                          </g>
                        </svg>{' '}
                      </button>
                    </div>
                  </div>
                  {year >= new Date().getFullYear() ? (
                    <Tabs
                      defaultActiveKey="AddHoliday"
                      id="holidays"
                      className="holidays_tab"
                    >
                      <Tab
                        eventKey="AddHoliday"
                        title={formatMessage('factory_schedule_add')}
                      >
                        <AddEditHolidaySchedule
                          id={-1}
                          selctedYear={year}
                          selectedDate={selectedDate || new Date()}
                        />
                      </Tab>

                      <Tab
                        eventKey="AddWeekend"
                        title={formatMessage('add_weekoff')}
                      >
                        <AddEditWeekend selctedYear={year} />
                      </Tab>
                    </Tabs>
                  ) : (
                    <div>{formatMessage('no_add_remove_allowed')}</div>
                  )}
                </div>
              </div>
              <div className="col-9">
                <div>
                  {!toggleView ? (
                    <div>
                      {allHolidayListData && allHolidayListData.length > 0 ? (
                        <div className="tableDesign factoryTable row-eq-height tableDevices p-3 changingPanel">
                          <div
                            className="table-responsive"
                            data-testid="table"
                          >
                            {allHolidayListData && (
                              <Grid
                                data={allHolidayListData}
                                columns={columns}
                                keyField="HolidayId"
                                loading={false}
                                rowClasses={rowClassFormat}
                                rowEvents={{ onClick: rowEvents }}
                                hover={true}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="message">
                          <div className="d-flex message-area">
                            <div className="no-data-img">
                              <img
                                src={noMessageIcon}
                                alt=""
                                className="no_message"
                              />
                            </div>
                            <div>
                              <h3 className="fw-bold display-6">
                                {' '}
                                <FormattedMessage id="no_holiday" />
                              </h3>
                              <h4 className="mb-3">
                                {formatMessage('no_holiday_message')}
                              </h4>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <CalendarView
                      selectedYear={year}
                      holidays={calendarHolidays}
                      weekends={weekendDays}
                      setSelectedDate={(date) => setSelectedDate(date)}
                      deleteHandler={calendarViewDeleteClickHandler}
                      language={language}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.HolidayName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <FactoryScheduleDetails
              selectedRowId={selectedRow.HolidayId}
              row={selectedRow}
            />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default DeleteAllFactorySchedulePopupHOC(
  ImportHolidayPopupHOC(
    AddHolidayCalendarPopupHOC(
      FilterPopupHOC(
        AddFactorySchedulePopupHOC(DeletePopupHOC(observer(FactorySchedule)))
      )
    )
  )
);
